// Mapping sub-modes
export type MappingSubMode =
  | 'update_existing' // Update existing location map
  | 'new_location' // New location in current facility
  | 'new_facility' // New facility
  | 'simple_legacy' // Simple (legacy) - no metadata needed

// Form data for mapping mode
export interface MappingFormData {
  subMode: MappingSubMode
  locationName?: string // For modes 2 and 3
  selectedLocationName?: string // For mode 1 (selected location)
  robotPosition?: import('geojson').Point // For mode 3 (from map)
  robotYaw?: number // For mode 3 (from map)
}

const LOCATION_NAME_ALLOWED_PATTERN = 'A-Za-z0-9_\\-()/'

export const LOCATION_NAME_ALLOWED_REGEX = new RegExp(`^[${LOCATION_NAME_ALLOWED_PATTERN}]+$`)
export const LOCATION_NAME_SANITIZE_REGEX = new RegExp(`[^${LOCATION_NAME_ALLOWED_PATTERN}]`, 'g')
export const LOCATION_NAME_ALLOWED_HINT =
  'Allowed characters: letters A-Z, digits 0-9, dash -, underscore _, parentheses (), slash /.'
